/**
 * 订阅计划类型
 */
export const SUBSCRIPTION_PLAN = {
  /**
   * Plus计划 - 会员基础版
   */
  PLUS: 'plus',
};

/**
 * 订阅周期类型
 */
export const SUBSCRIPTION_INTERVAL = {
  /**
   * 月度订阅
   */
  MONTH: 'month',
  /**
   * 年度订阅
   */
  YEAR: 'year',
};

/**
 * 订阅状态类型定义 - 使用字符串字面量联合类型
 * 建议在代码中直接使用此类型进行类型检查
 */
export type SubscriptionStatusType = 
  | 'active'      // 活跃状态 - 有效订阅
  | 'trialing'    // 试用期 - 免费试用中
  | 'incomplete'  // 未完成 - 等待支付
  | 'incomplete_expired' // 未完成已过期 - 支付失败且已过期
  | 'canceled'    // 过期 - 已取消且到期
  | 'past_due'    // 支付逾期 - 等待补交费用
  | 'unpaid';     // 未支付 - 需要手动处理的未付款状态

/**
 * 订阅状态枚举 - 为了与Stripe API保持一致
 */
export enum SubscriptionStatus {
  /**
   * 活跃状态 - 有效订阅
   */
  ACTIVE = 'active',
  /**
   * 试用期 - 免费试用中
   */
  TRIALING = 'trialing',
  /**
   * 未完成 - 等待支付
   */
  INCOMPLETE = 'incomplete',
  /**
   * 未完成已过期 - 支付失败且已过期
   */
  INCOMPLETE_EXPIRED = 'incomplete_expired',
  /**
   * 过期 - 已取消且到期
   */
  CANCELED = 'canceled',
  /**
   * 支付逾期 - 等待补交费用
   */
  PAST_DUE = 'past_due',
  /**
   * 未支付 - 需要手动处理的未付款状态
   */
  UNPAID = 'unpaid',
}

/**
 * 订阅状态常量对象 - 兼容现有代码
 * @deprecated 建议使用 SubscriptionStatus 枚举替代
 */
export const SUBSCRIPTION_STATUS = {
  /**
   * 活跃状态 - 有效订阅
   */
  ACTIVE: SubscriptionStatus.ACTIVE,
  /**
   * 试用期 - 免费试用中
   */
  TRIALING: SubscriptionStatus.TRIALING,
  /**
   * 未完成 - 等待支付
   */
  INCOMPLETE: SubscriptionStatus.INCOMPLETE,
  /**
   * 未完成已过期 - 支付失败且已过期
   */
  INCOMPLETE_EXPIRED: SubscriptionStatus.INCOMPLETE_EXPIRED,
  /**
   * 过期 - 已取消且到期
   */
  CANCELED: SubscriptionStatus.CANCELED,
  /**
   * 支付逾期 - 等待补交费用
   */
  PAST_DUE: SubscriptionStatus.PAST_DUE,
  /**
   * 未支付 - 需要手动处理的未付款状态
   */
  UNPAID: SubscriptionStatus.UNPAID,
};

/**
 * 各订阅计划的功能列表
 */
export const PLAN_FEATURES = {
  [SUBSCRIPTION_PLAN.PLUS]: [
    'unlimited_tasks', // 无限任务
    'ai_chat', // AI聊天
    'calendar_sync', // 日历同步
    'premium_support', // 高级支持
    'task_prioritization', // 任务优先级
  ],
};

/**
 * 接口：价格信息定义
 */
export interface PriceInfo {
  id: string; // Stripe价格ID
  amount: number; // 金额（分）
  currency: string; // 货币
  formattedAmount: string; // 格式化金额
  interval: string; // 周期
  discount?: number; // 折扣比例（如果有）
}

/**
 * 接口：产品价格映射
 */
export interface ProductPrices {
  [planId: string]: {
    [interval: string]: PriceInfo
  }
} 